import styled from '@emotion/styled';
import { Dayjs } from 'lib/dayjs';
import { useMemo, useState } from 'react';
import { last30days } from '../../utils';
import ExtraNode from '../Filter/ExtraNode';
import FilterProvider from '../Filter/Provider';
import TrendDrawer from '../Trend';
import TrendProvider from '../Trend/TrendProvider';
import Recover, { CommonContainer } from './Recover';
import Wastage from './Wastage';
import { useDashboardPlatformInfo } from '../Filter/useFilter';

const Container = styled(CommonContainer)`
  .ant-card-body {
    padding: 0;
  }
`;

const Content = () => {
  const [_tab, setTab] = useState<'非COD订单损耗情况' | 'COD订单损耗情况'>('非COD订单损耗情况');

  const {
    platformInfo: { isOnlyMercado },
  } = useDashboardPlatformInfo();

  const tab = isOnlyMercado ? '非COD订单损耗情况' : _tab;

  return (
    <Container>
      <Wastage key="tab-wastage" tab={tab} setTab={setTab} />
      <Recover key="tab-recover" tab={tab} />
    </Container>
  );
};

const OrderWastage = () => {
  const initialValue = useMemo(() => {
    const [start, end] = last30days();

    const defaultDateRange = [start.subtract(7, 'day'), end.subtract(6, 'day')] as [Dayjs, Dayjs];

    return {
      storeInfo: {},
      dateRange: defaultDateRange,
    };
  }, []);

  return (
    <FilterProvider
      initialValue={initialValue}
      rightExtra={(props) => (
        <ExtraNode {...props} max={initialValue.dateRange[1]} dashboardName="OrderLoss" />
      )}
      dashboardName="OrderLoss"
      scene="ORDER_STAT"
    >
      <TrendProvider>
        <Content />
        <TrendDrawer />
      </TrendProvider>
    </FilterProvider>
  );
};

export default OrderWastage;
